import { PropsWithChildren, ReactNode } from 'react';
import { cn, IconButton, Image } from '@ds';
import { MdOutlineModeEditOutline } from 'react-icons/md';
import { ConditionalRender } from '@ui';

type TabSectionProps = {
  titleIcon?: {
    src: string;
    classNames: string;
  };
  title: string;
  onSectionEdit?: () => void;
  actionRender?: ReactNode;
  titleClassName?: string;
} & PropsWithChildren;

const TabSection = ({
  titleIcon,
  title,
  onSectionEdit,
  actionRender,
  titleClassName = 'h-6',
  children,
}: TabSectionProps) => (
  <section className="flex flex-col flex-1">
    <div className="flex justify-between items-center mb-4">
      <div className="flex gap-2 items-center">
        <ConditionalRender show={Boolean(titleIcon)}>
          <div className={cn('w-6 h-6 flex justify-center items-center rounded-full', titleIcon?.classNames)}>
            <Image src={titleIcon?.src} alt={`${title} image`} />
          </div>
        </ConditionalRender>
        <h3 id={title} className={cn('text-hm', titleClassName)}>
          {title}
        </h3>
      </div>
      {onSectionEdit && (
        <IconButton
          size="sm"
          className="min-h-6"
          variant="light"
          startContent={<MdOutlineModeEditOutline />}
          onClick={onSectionEdit}
        />
      )}
      {actionRender}
    </div>
    {children}
  </section>
);

export default TabSection;
